import React, { Component } from 'react';

class CardGto extends Component {

  componentWillMount() {
    this.regraColors();
  }

  componentWillReceiveProps = props => {
    this.regraColors(props);
  };

  regraColors = (props = null) => {
    let procedimentos = {
      GLOSADO: [],
      BLOQUEADO: [],
      EM_ANALISE: [],
      APROVADO: [],
      RECURSADO: []
    };
    /*
    TODO:
    saber quais são os demais retornos dos status, precisei trocar o "analise" para "EM_ANALISE"

      EM_ANALISE
      GLOSADO
      APROVADO
      RECURSADO
      LIBERADO
      BLOQUEADO

    */

    let color = '';

    props = props === null ? this.props : { ...this.props, ...props };

    props.state.procedures.forEach(procedimento => {
      if (!procedimentos[procedimento.status]) {
        // foi criado para o caso de um status não estar mapeado
        console.warn("O status ", procedimento.status, " não estava mapeado!")
        procedimentos[procedimento.status] = []
      }
      procedimentos[procedimento.status].push(procedimento);
    });

    if (procedimentos.EM_ANALISE.length) {
      color = 'blue';
    }

    if (procedimentos.BLOQUEADO.length) {
      color = 'yellow';
    }

    if (procedimentos.GLOSADO.length) {
      color = 'red';
    }

    if (procedimentos.RECURSADO.length) {
      color = 'red';
    }

    this.setState({
      cardColor: color,
      procedimentos
    });
  };

  render() {
    const { gto, procedures } = this.props.state;
    const { beneficiary } = this.props

    return (
      <li className="card">
        <div>
          <div className={`CardWithLateralLine CardWithLateralLine--${this.state.cardColor}`}>
            <div className="col s12">
              <div className="row">
                <div className="col s6 align-left">
                  <div className="box-label box-label--top">
                    <span className={`box-label--name ${this.state.cardColor}`}>
                      GTO {gto.gtoId}
                    </span>
                    <span className="box-label--numberCard benefCod">{beneficiary.nomeBenef}</span>
                  </div>
                  {/* <div className="box-label box-label--bottom">
                    <span>Emissão</span>
                    <span className="box-label--dateStart bottomLeftDescription">
                      {inclusionDateFormated}
                    </span>
                  </div> */}
                </div>

                <div className="col s6 align-right">
                  <div className="box-label box-label--top">
                    <span className="box-label--consult benefElegivel">
                      {`${procedures.length} Procedimento${procedures.length > 1 ? 's' : ''}`}
                    </span>
                    <div>
                      {this.state.procedimentos.BLOQUEADO.length > 0 && (
                        <span className="box-label--status upperRightDescription --yellow">
                          <p>{this.state.procedimentos.BLOQUEADO.length}</p>
                        </span>
                      )}

                      {this.state.procedimentos.GLOSADO.length > 0 && (
                        <span className="box-label--status upperRightDescription --red">
                          <p>{`${this.state.procedimentos.GLOSADO.length} `}</p>
                        </span>
                      )}

                      {this.state.procedimentos.EM_ANALISE.length > 0 && (
                        <span className="box-label--status upperRightDescription --blue">
                          <p>{this.state.procedimentos.EM_ANALISE.length}</p>
                        </span>
                      )}

                      {this.state.procedimentos.RECURSADO.length > 0 && (
                        <span className="box-label--status upperRightDescription --red">
                          <p>{`${this.state.procedimentos.RECURSADO.length} `}</p>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  }
}

export default CardGto;
